jQuery(function($) {
    
    if($('header#masterHeader').length > 0) {
        var siteWrapper = $('.site-content');

        $(window).on('scroll load', function(){
            var header = $('header#masterHeader'),
                stickyStart = header.outerHeight() + 100,
                stickyOffset = $(window).scrollTop();

            if (stickyStart < stickyOffset) {
                if(!header.hasClass('site-header--overlay')) {
                  siteWrapper.css('padding-top', header.outerHeight() + 'px');
                }
                header.addClass('sticky');
            } else {
                if(!header.hasClass('site-header--overlay')) {
                  siteWrapper.css('padding-top', '0');
                }
                header.removeClass('sticky');
            }
        });
    }

	$('body').on('click', '.mobile-toggler-burger', function(e) {
		e.preventDefault();

		var t = $(this),
			href = t.attr('href');

		if (href == '#openNav-mobile') {
			$('#mobile-nav').addClass('open');
		} else {
			$('#mobile-nav').removeClass('open');
		}

	});

// UPDATED: Testimonials slider with autoplay and proper 2-per-view
var testimonialsSlider = new Swiper(".testimonials-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        575: {
            slidesPerView: 2,
            spaceBetween: 30,
        }
    },
    // Add autoplay only if more than 2 slides
    autoplay: document.querySelectorAll('.testimonials-slider .swiper-slide').length > 2 ? {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
    } : false,
    // Only loop if more than 2 slides to avoid blank pages
    loop: document.querySelectorAll('.testimonials-slider .swiper-slide').length > 2
});

// Newsletter popup
	$('body').on('click', '[href="#openNewsletter"]', function(e) {
      $('.site_newsletter-popup').addClass('open');
    });
	$('body').on('click', '[href="#closeNewsletter"]', function(e) {
      $('.site_newsletter-popup').removeClass('open');
    });
// Retail redirect popup popup
  	$('body').on('click', '[href="#openRedirect"]', function(e) {
      $('#pop_retail').addClass('open');
    });
	$('body').on('click', '[href="#closeRedirect"]', function(e) {
      $('#pop_retail').removeClass('open');
    });

    if (window.location.href.indexOf("vdd=yes") > -1) {
      $('#pop_retail').addClass('open');
    }

// Wholesale redirect popup popup
  	$('body').on('click', '[href="#openWholesale"]', function(e) {
      $('#pop_wholesale').addClass('open');
    });
	$('body').on('click', '[href="#closeWholesale"]', function(e) {
      $('#pop_wholesale').removeClass('open');
    });

    if (window.location.href.indexOf("vdd=practitioners") > -1) {
      $('#pop_wholesale').addClass('open');
    }

// Wholesale redirect popup popup
  	$('body').on('click', '[href="#openPublicsq"]', function(e) {
      $('#pop_publicsq').addClass('open');
    });
	$('body').on('click', '[href="#closePublicsq"]', function(e) {
      $('#pop_publicsq').removeClass('open');
    });

    if (window.location.href.indexOf("publicsq=") > -1) {
      $('#pop_publicsq').addClass('open');
    }
  
});

document.addEventListener('DOMContentLoaded', function() {
  const mobileMenu = document.querySelector('[data-drawer], .menu-drawer, .drawer, .mobile-nav'); // adjust selector if needed
  const menuLinks = document.querySelectorAll('.menu-drawer a[href^="#"], .mobile-nav a[href^="#"]');

  menuLinks.forEach(link => {
    link.addEventListener('click', function() {
      // Let the browser scroll first
      setTimeout(() => {
        if (mobileMenu && mobileMenu.classList.contains('open')) {
          // Common Shopify Dawn toggle
          mobileMenu.classList.remove('open');
          document.body.classList.remove('js-drawer-open'); 
        }

        // If your theme uses CHECKBOX toggle for menu
        const menuToggle = document.querySelector('input[type="checkbox"][id*="menu"]');
        if (menuToggle) {
          menuToggle.checked = false;
        }

        // If a close button exists
        const closeButton = mobileMenu?.querySelector('[data-drawer-close]');
        if (closeButton) closeButton.click();
      }, 300); // small delay lets scroll happen first
    });
  });
});